(function() {
'use strict';

angular
    .module('TR')
    .controller('HotelsFilter', HotelsFilter);

function HotelsFilter($scope, hotelSearch, broker, resourceService, hotelsFilter) {
    const hf = this;
    let agg;

    hf.newSearch = true;

    hotelSearch.getFilterLazy().then(function(filter) {
        hf.filter = filter;
    });

    broker.subscribe('HotelsFilterCtrl', 'newSearchTriggered', newSearchTriggered);

    broker.subscribe('HotelsFilterCtrl', 'hotelListUpdated', function(ev) {
        updateFilter();
        if (ev.data.Aggregates) {
            configureFilterLimits(ev.data);
        }
        watchFilter();
    });

    $scope.$on('$destroy', function() {
        broker.unsubscribe('HotelsFilterCtrl');
    });

    function configureFilterLimits(results) {
        agg = results.Aggregates;

        if (hf.filterLimits == null) {
            hf.filterLimits = hotelsFilter.getFilterLimits(agg);
        }

        hf.moreLess = function(filterName) {
            if (!agg[`${filterName}Array`] || (agg[`${filterName}Array`].length <= hotelsFilter.config[filterName].limit)) {
                return '';
            }
            if (hf.filterLimits[filterName] <= hotelsFilter.config[filterName].limit) {
                return resourceService.get('MORE');
            }
            if (hf.filterLimits[filterName] > hotelsFilter.config[filterName].limit) {
                return resourceService.get('FEWER');
            }
        };

        hf.toggleLimit = function(filterName) {
            hf.filterLimits[filterName] = (hf.filterLimits[filterName] < agg[`${filterName}Array`].length) ? agg[`${filterName}Array`].length : hotelsFilter.config[filterName].limit;
        };

        function toggleOpenSelected() {
            if (hf.newSearch === false) {
                return;
            }
            for (const i in agg) {
                if (typeof agg[`${i}Array`] !== 'undefined') {
                    if (i.indexOf('HotelsBy') >= 0) {
                        const name = i.replace('HotelsBy', '');
                        //check in singular and plural form of model
                        const f = hf.filter[name] || hf.filter[`${name}s`];
                        hf.filterLimits[i] = f && f.length > 0 ? agg[`${i}Array`].length : hf.filterLimits[i];
                    } else if (checkFacilities(i)) {
                        hf.filterLimits[i] = agg[`${i}Array`].length;
                    }
                }
            }
            hf.newSearch = false;
        }

        toggleOpenSelected();

        function checkFacilities(filterName) {
            return _.some(agg[`${filterName}Array`], v => v.name && _.includes(hf.filter.FacilityCodes, v.name));
        }
    }

    ['removeFilter', 'removeArrayFilter', 'resetArrayFilter', 'resetBitFilter', 'resetRangeFilter', 'resetFilters'].forEach(function(fn) {
        hf[fn] = function(...args) {
            stopWatch();
            return hotelSearch[fn](...args).then(watchFilter).then(updateFilter);
        };
    });

    hf.resetFacilityFilter = function(group) {
        stopWatch();
        const codesInGroup = [];
        for (const code in agg[group]) {
            codesInGroup.push(code);
        }
        return hotelSearch.removeFiltersIn('FacilityCodes', codesInGroup).then(watchFilter).then(updateFilter);
    };

    function updateFilter() {
        hf.filter = hotelSearch.getFilter();
    }

    let canceller;
    function stopWatch() {
        canceller && canceller();
    }

    function watchFilter() {
        stopWatch();
        canceller = $scope.$watch('hf.filter', _.debounce(function(filter, old) {
            if (filter == null || _.isEqual(filter, old)) {
                return;
            }
            //this filter has changed therefore we have to remove any estab group filter just in case
            hotelSearch.filter().then(updateFilter);
        }, 300), true);
    }


    //the reason that filters need to be reset when a new search is triggered is because the filter criteria
    //are built from the aggregates which will be completely different when the search results load. So
    //don't be tempted to remove this. Seriously.
    //Furthermore when we trigger a new search, becuase we have to reset the filters we also need to suspend
    //the watch until those results have been resolved otherwise we get double calling of the getHotelsFromSession
    //Fragile? absolutely.
    function newSearchTriggered() {
        hf.newSearch = true;
        hf.resetFilters().then(stopWatch);
    }
}
})();
